export default function initHomeServices() {
    const homeServices = document.querySelector(".home-services");
    if (!homeServices)
        return;
    const serviceItems = homeServices.querySelectorAll(".home-service");
    if (!serviceItems.length)
        return;
    const setItemWidth = (item) => {
        const title = item.children[0];
        if (!title)
            return;
        item.style.setProperty("--max-width", `${title.offsetWidth + 24}px`);
    };
    serviceItems.forEach((item) => {
        const title = item.children[0];
        if (!title)
            return;
        setItemWidth(item);
        title.addEventListener("click", () => {
            item.classList.toggle("active");
            setTimeout(() => {
                item.classList.toggle("overflow-active");
            }, 400);
        });
    });
    window.addEventListener("resize", () => {
        serviceItems.forEach(setItemWidth);
    });
}
